import React from 'react';

const Icon = ({ children }) => {
  return (
    <i className="material-icons" aria-hidden="true">
      {children}
    </i>
  );
};

export default Icon;
